/**
 * @generated SignedSource<<bfadbd05b1f827457e86fd2c08750196>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type row_nativeIssueTable_RowWithDragAndDrop_fieldSets$data = {
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_RowInner_fieldSets">;
  readonly " $fragmentType": "row_nativeIssueTable_RowWithDragAndDrop_fieldSets";
};
export type row_nativeIssueTable_RowWithDragAndDrop_fieldSets$key = {
  readonly " $data"?: row_nativeIssueTable_RowWithDragAndDrop_fieldSets$data;
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_RowWithDragAndDrop_fieldSets">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "row_nativeIssueTable_RowWithDragAndDrop_fieldSets",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        },
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        },
        {
          "kind": "Variable",
          "name": "isInlineEditingEnabled",
          "variableName": "isInlineEditingEnabled"
        },
        {
          "kind": "Variable",
          "name": "isTimelineEnabled",
          "variableName": "isTimelineEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "row_nativeIssueTable_RowInner_fieldSets"
    }
  ],
  "type": "JiraIssueFieldSetConnection"
};

(node as any).hash = "780c4baf41d3aefe6a98e21336093bc0";

export default node;
